<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :tables="pageData"
      isFooter="true"
    >
      <template v-slot:[pageData[0].name]="{ item }">
        <slot :name="pageData[0].name" v-bind:item="item" />
      </template>
      <template v-slot:[pageData[1].name]="{ item }">
        <ProductTable
          :headers="item.productHeaders"
          :items="item.items"
          :item-key="item.itemKey"
        >
        </ProductTable>
      </template>
      <template #footer>
        <v-spacer> </v-spacer>
        <div class="ma-2 btnStyle">
          <NormalButton
            :text="$t('common.input_save')"
            textSize="16px"
            height="50px"
            width="100%"
            @click="register()"
          />
        </div>
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import MultipleAreaBase from '../MultipleAreaBase'
import ProductTable from '@/components/items/Tables/ProductTable'

import { NormalButton } from '@/components/items'

export default {
  components: {
    MultipleAreaBase,
    ProductTable,
    NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },

    pageData: [
      // {
      //   title: { default: '' },
      //   name: { default: '' },
      //   items: { default: [] },
      //   itemKey: { default: '' }
      // }
    ]
  },
  data: () => ({
    //
  }),
  methods: {
    register() {
      this.$emit('register')
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    // padding-left: 30px;
  }
  // ::v-deep .v-data-table td {
  //   padding-left: 30px;
  // }
}
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 130px;
}
</style>
